<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/coupon_group/"
                       data-key="groups"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-on="$listeners"
                       v-bind="$attrs">
    <template v-slot:item.actions="{item}">
      <v-tooltip top>
        <template #activator="{on, attrs}">
          <v-btn icon
                 v-on="on"
                 v-bind="attrs"
                 @click="editItem(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('edit') }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template #activator="{on, attrs}">
          <v-btn icon
                 v-on="on"
                 v-bind="attrs"
                 @click="deleteItem(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('delete') }}</span>
      </v-tooltip>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import ListDiscountCodeRecordModal from "@/components/acc_booking/discount_code/ListDiscountCodeRecordModal.vue";
import EditCouponGroupModal from "@/components/acc_booking/coupon/EditCouponGroupModal.vue";

export default {
  name: 'AdminCouponGroupList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    extraParams: Object,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_acc_coupon_group.name'), value: 'name', contains: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_acc_coupon_group.name'), value: 'name'},

      {text: '', value: 'actions', sortable: false, width: 150},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const deleteItem = function (item) {
      if (confirm(root.$t('admin_acc_coupon_group.delete_confirm_msg'))) {
        root.$callAPI('aafb/admin/coupon_group/delete/', {
          coupon_group_id: item.id,
        }, (response) => {
          refresh();
        })
      }
    }
    const editItem = async function (item) {
      await root.$dialog.showAndWait(EditCouponGroupModal, {
        couponGroupId: item.id,
        persistent: true,
        width: '80vw',
      })
    };
    const listItemRecords = async function (item) {
      await root.$dialog.showAndWait(ListDiscountCodeRecordModal, {
        couponGroupId: item.id,
        persistent: true,
        width: '80vw',
      })
    }

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      deleteItem,
      editItem,
      listItemRecords,
    }
  }
}
</script>
